import { render, staticRenderFns } from "./MoleculeMenuTrigger.vue?vue&type=template&id=94943950&"
import script from "./MoleculeMenuTrigger.vue?vue&type=script&lang=js&"
export * from "./MoleculeMenuTrigger.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeMenuTrigger.vue?vue&type=style&index=0&id=94943950&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default})
